import { mixpanel } from '@affine/track';

mixpanel.init();
